<template>
    <div class="s-request-status__controls">
        <div v-if="!resultsView" class="s-request-status__controls__item">
            <button class="e-btn" type="button" @click="submitClicked">{{ appData.dictionary.submitBtn }}</button>
        </div>
        <div v-if="!resultsView" class="s-request-status__controls__item">
            <a href="javascript:void(0)" class="dotted-link" @click="resetClicked">{{ appData.dictionary.resetBtn }}</a>
        </div>
        <div v-if="resultsView" class="s-request-status__controls__item">
            <button class="e-btn" type="button" @click="resetClicked">{{ appData.dictionary.newSearchBtn }}</button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        resultsView: {
            type: Boolean,
            default: false,
        },
    },

    emits: ['submit-clicked', 'reset-clicked'],

    methods: {
        submitClicked() {
            this.$emit('submit-clicked')
        },

        resetClicked() {
            this.$emit('reset-clicked')
        },
    },
}
</script>
